import HeatMap from './HeatMap';

export default HeatMap;



// WEBPACK FOOTER //
// ./src/index.js